<ng-container *transloco="let t">
  <ng-container *ngFor="let v of values$ | async">
    <div>
      <label class="mr-1">{{t('alert-sms-report.message')}}:</label>
      <div class="p-2" [innerHtml]="v.message"></div>
    </div>
    <div class="row">
      <div class="col-1">
        <label>{{t('alert-sms-report.phoneNrs')}}:</label>
      </div>
      <div class="col-11 text-left">
        <ul>
          <li *ngFor="let pn of v.phoneNrs">
            <span class="font-weight-bold">{{pn.phoneNr}}</span>
            (<small *ngIf="pn.sent">{{t('alert-sms-report.sent')}}</small>
            <small *ngIf="!pn.sent" class="text-danger">{{t('alert-sms-report.notSent')}}</small>)
          </li>
        </ul>
      </div>
    </div>
  </ng-container>
</ng-container>
